module.exports = __webpack_public_path__ + "static/media/template-stocks.45b09250.csv";